import Vue from 'vue';
import Html from './phone.vue';

Vue.component('oa-phone', Html);



// WEBPACK FOOTER //
// ./ClientApp/shared/phone.js